import { wrapLazily } from "../lazy-loading/lazyWrapper";

function getOrderHistoryPageComponent(orderType) {
	return wrapLazily(
		() =>
			import("explore_ui/OrderHistoryPage").then(({ getOrderHistoryPage }) => ({
				default: props => getOrderHistoryPage(props, orderType),
			})),
		{
			usesBootstrap: true,
			usesMoment: true,
			usesReactAdapter: true,
		},
	);
}

export const routes = () => {
	return [
		// TODO (CF) In case of /ordercapture route is no longer used delete the "/ordercapture" route
		// TODO (EK) /list route is here only for legacy reasons and could be removed at some point in 2018
		{
			path: "/ordercapture",
			onEnter: (_noUsed, replace) => replace("/"),
		},
		{
			path: "/storelistOverview",
			component: wrapLazily(() => import("explore_ui/StoreListOverviewPage"), {
				usesBootstrap: true,
				usesMoment: true,
			}),
			routeParam: {
				trackingName: "storelistOverview",
				visibleForAnonymous: true,
			},
		},
		{
			path: "/listOverview",
			component: wrapLazily(() => import("explore_ui/ListOverviewPage"), {
				usesBootstrap: true,
				usesMoment: true,
			}),
			routeParam: {
				trackingName: "listOverview",
				visibleForAnonymous: true,
			},
		},
		{
			path: "/list",
			childRoutes: [
				{
					path: "/list/:ListId",
					component: wrapLazily(() => import("explore_ui/ShoppingListPage"), {
						usesBootstrap: true,
						usesMoment: true,
					}),
					routeParam: {
						trackingName: "list",
						invisibleForTier12: true,
					},
				},
			],
		},
		{
			path: "/shoppingList",
			childRoutes: [
				{
					path: "/shoppingList/:ListId",
					component: wrapLazily(() => import("explore_ui/ShoppingListPage"), {
						usesBootstrap: true,
						usesMoment: true,
					}),
					routeParam: {
						trackingName: "shoppingList",
						invisibleForTier12: true,
					},
				},
			],
		},
		{
			path: "/historylist",
			childRoutes: [
				{
					path: "/historylist/:ListId",
					component: wrapLazily(() => import("explore_ui/HistoryListPage"), {
						usesBootstrap: true,
						usesMoment: true,
					}),
					routeParam: {
						trackingName: "historyList",
						invisibleForTier12: true,
					},
				},
			],
		},
		{
			path: "/addnewaddress",
			component: wrapLazily(() => import("explore_ui/AddAddressPageWithRedirect"), {
				usesBootstrap: true,
				usesMoment: true,
			}),
			routeParam: {
				trackingName: "addNewAddress",
				invisibleForTier12: true,
			},
		},
		{
			path: "/portal",
			component: wrapLazily(() => import("explore_ui/CustomerPortalPage"), {
				usesBootstrap: true,
				usesMoment: true,
			}),
			indexRoute: {
				onEnter: (_nextState, redirect) => redirect("/portal/overview/customer-information"),
			},
			routeParam: {
				trackingName: "customerPortal",
				invisibleForTier12: true,
			},
			childRoutes: [
				// marketplace order pages (all use the same chunk)
				{
					path: "/portal/:orderId/submit-message/:marketplaceOrderId",
					component: wrapLazily(() => import("explore_ui/SubmitMessagePage"), {
						usesBootstrap: true,
						usesMoment: true,
						usesReactAdapter: true,
					}),
					routeParam: {
						trackingName: "submitMessagePage",
						invisibleForTier12: true,
					},
				},
				{
					path: "/portal/address-management",
					component: wrapLazily(() => import("explore_ui/AddressSection"), {
						usesBootstrap: true,
						usesMoment: true,
						usesReactAdapter: true,
					}),
					routeParam: {
						trackingName: "customerPortal",
						invisibleForTier12: true,
					},
					childRoutes: [
						{
							path: "/portal/address-management/add",
							component: wrapLazily(() => import("explore_ui/AddAddress"), {
								usesBootstrap: true,
								usesMoment: true,
								usesReactAdapter: true,
							}),
							routeParam: {
								trackingName: "customerPortal",
								invisibleForTier12: true,
							},
						},
						{
							path: "/portal/address-management/edit/:id",
							component: wrapLazily(() => import("explore_ui/EditAddress"), {
								usesBootstrap: true,
								usesMoment: true,
								usesReactAdapter: true,
							}),
							routeParam: {
								trackingName: "customerPortal",
								invisibleForTier12: true,
							},
						},
						{
							path: "/portal/address-management/my-delivery-addresses",
							component: wrapLazily(() => import("explore_ui/DeliveryAddressList"), {
								usesBootstrap: true,
								usesMoment: true,
								usesReactAdapter: true,
							}),
							routeParam: {
								trackingName: "customerPortal",
								invisibleForTier12: true,
							},
						},
						{
							path: "/portal/address-management/*",
							component: wrapLazily(() => import("explore_ui/AddressList"), {
								usesBootstrap: true,
								usesMoment: true,
								usesReactAdapter: true,
							}),
							routeParam: {
								trackingName: "customerPortal",
								invisibleForTier12: true,
							},
						},
					],
				},
				{
					path: "/portal/overview",
					component: wrapLazily(() => import("explore_ui/OverviewSection"), {
						usesBootstrap: true,
						usesMoment: true,
						usesReactAdapter: true,
					}),
					routeParam: {
						trackingName: "customerPortal",
						invisibleForTier12: true,
					},
					childRoutes: [
						{
							path: "/portal/overview/my-company",
							component: wrapLazily(() => import("explore_ui/MyCompany"), {
								usesBootstrap: true,
								usesMoment: true,
								usesReactAdapter: true,
							}),
							routeParam: {
								trackingName: "customerPortal",
								invisibleForTier12: true,
							},
						},
						{
							path: "/portal/overview/my-cmr-statements",
							component: wrapLazily(() => import("explore_ui/MyCMRStatements"), {
								usesBootstrap: true,
								usesMoment: true,
								usesReactAdapter: true,
							}),
							routeParam: {
								trackingName: "customerPortal",
								invisibleForTier12: true,
							},
						},
						{
							path: "/portal/overview/customer-information",
							component: wrapLazily(() => import("explore_ui/CustomerInformations"), {
								usesBootstrap: true,
								usesMoment: true,
								usesReactAdapter: true,
							}),
							routeParam: {
								trackingName: "customerPortal",
								invisibleForTier12: true,
							},
						},
						{
							path: "/portal/overview/loyaltypoints",
							component: wrapLazily(() => import("explore_ui/LoyaltypointsPage"), {
								usesBootstrap: true,
								usesMoment: true,
								usesReactAdapter: true,
							}),
							routeParam: {
								trackingName: "customerPortal",
								invisibleForTier12: true,
							},
						},
						{
							path: "/portal/overview/payments",
							component: wrapLazily(() => import("explore_ui/PaymentsPage"), {
								usesBootstrap: true,
								usesMoment: true,
								usesReactAdapter: true,
							}),
							routeParam: {
								trackingName: "customerPortal",
								invisibleForTier12: true,
							},
						},
					],
				},
				{
					path: "/portal/change-email",
					component: wrapLazily(() => import("explore_ui/ChangeEmailForm"), {
						usesBootstrap: true,
						usesMoment: true,
						usesReactAdapter: true,
					}),
					routeParam: {
						trackingName: "changeEmail",
						invisibleForTier12: true,
					},
				},
				{
					path: "/portal/change-email-confirmation",
					component: wrapLazily(() => import("explore_ui/ChangeEmailConfirmation"), {
						usesBootstrap: true,
						usesMoment: true,
						usesReactAdapter: true,
					}),
					routeParam: {
						trackingName: "changeEmailConfirmation",
						invisibleForTier12: true,
					},
				},
				{
					path: "/portal/my-orders",
					routeParam: {
						trackingName: "customerPortalMyOrders",
						invisibleForTier12: true,
					},
					childRoutes: [
						{
							path: "/portal/my-orders/all",
							component: getOrderHistoryPageComponent("all"),
							routeParam: {
								trackingName: "customerPortalMyOrdersAll",
								invisibleForTier12: true,
							},
						},
						{
							path: "/portal/my-orders/latest-order",
							component: wrapLazily(() => import("explore_ui/OrderHistoryParkingPage"), {
								usesBootstrap: true,
								usesMoment: true,
								usesReactAdapter: true,
							}),
							routeParam: {
								trackingName: "customerPortalLatestOrderRedirect",
								doNotTrackInHook: true,
								invisibleForTier12: true,
							},
						},
						{
							path: "/portal/my-orders/delivered",
							component: getOrderHistoryPageComponent("delivered"),
							routeParam: {
								trackingName: "customerPortalMyOrdersDelivered",
								invisibleForTier12: true,
							},
						},
						{
							path: "/portal/my-orders/open",
							component: getOrderHistoryPageComponent("open"),
							routeParam: {
								trackingName: "customerPortalMyOrdersOpen",
								invisibleForTier12: true,
							},
						},
						{
							path: "/portal/my-orders/cancelled",
							component: getOrderHistoryPageComponent("cancelled"),
							routeParam: {
								trackingName: "customerPortalMyOrdersCancelled",
								invisibleForTier12: true,
							},
						},
						{
							path: "/portal/my-orders/:orderId",
							component: wrapLazily(() => import("explore_ui/OrderHistoryDetailPage"), {
								usesBootstrap: true,
								usesMoment: true,
								usesReactAdapter: true,
							}),
							routeParam: {
								trackingName: "orderHistoryDetail",
								noCustomerNeed: false,
								visibleForAnonymous: false,
								invisibleForTier12: true,
							},
						},
						{
							path: "/portal/redirect-order/:subOrderId",
							component: wrapLazily(() => import("explore_ui/OrderHistoryDetailRedirectPage"), {
								usesBootstrap: true,
								usesMoment: true,
								usesReactAdapter: true,
							}),
							routeParam: {
								trackingName: "orderHistoryDetailFromLink",
								noCustomerNeed: false,
								visibleForAnonymous: false,
								invisibleForTier12: true,
							},
						},
					],
				},
			],
		},
		{
			path: "/selectAccount",
			component: wrapLazily(() => import("explore_ui/AccountSelectionPage"), {
				usesBootstrap: true,
				usesMoment: true,
			}),
			routeParam: {
				trackingName: "selectAccount",
				invisibleForTier12: true,
			},
		},
		{
			path: "/selectAddress",
			component: wrapLazily(() => import("explore_ui/AddressSelectionPage"), {
				usesBootstrap: true,
				usesMoment: true,
			}),
			routeParam: {
				trackingName: "selectAddress",
				doNotTrackInHook: true,
				visibleForAnonymous: true,
			},
			childRoutes: [
				{
					path: "/selectAddress/",
					routeParam: {
						trackingName: "selectAddress",
					},
				},
				{
					path: "/selectAddress/:redirect",
					routeParam: {
						trackingName: "selectAddress",
					},
				},
				{
					path: "/selectAddress/:redirect/:forceSelection",
					routeParam: {
						trackingName: "selectAddress",
					},
				},
			],
		},
		{
			path: "reorder",
			component: wrapLazily(() => import("explore_ui/ReorderPage"), {
				usesBootstrap: true,
				usesMoment: true,
			}),
			routeParam: {
				trackingName: "reorder",
				invisibleForTier12: true,
			},
			childRoutes: [
				{
					path: "/reorder/:orderId",
					component: wrapLazily(() => import("explore_ui/ReorderPage"), {
						usesBootstrap: true,
						usesMoment: true,
						usesReactAdapter: true,
					}),
					routeParam: {
						trackingName: "reorder",
						invisibleForTier12: true,
					},
				},
			],
		},
		{
			path: "/public/email-change-success",
			component: wrapLazily(() => import("explore_ui/ChangeEmailSuccessMessagePage"), {
				usesBootstrap: true,
				usesMoment: true,
			}),
			routeParam: {
				trackingName: "change-email-success",
				noCustomerNeed: true,
			},
		},
		{
			path: "/public/email-change-failure",
			component: wrapLazily(() => import("explore_ui/ChangeEmailFailedMessagePage"), {
				usesBootstrap: true,
				usesMoment: true,
			}),
			routeParam: {
				trackingName: "change-email-failure",
				noCustomerNeed: true,
			},
		},
		{
			path: "/account",
			onEnter: (_notUsed, replace) => replace("/portal"),
			routeParam: {
				trackingName: "accountPage -> customerPortal",
				noCustomerNeed: false,
			},
		},
	];
};
export const LandingPage = wrapLazily(() => import("explore_ui/LandingPage"), {
	usesBootstrap: true,
	usesMoment: true,
});
